import EndpointIndex from '@/endpoint/views/Index.vue';
import Edit from '@/endpoint/views/Edit.vue';
import Create from '@/endpoint/views/Create.vue';

const routes = [
  {
    path: '/endpoint/',
    name: 'Endpoint-Index',
    component: EndpointIndex,
  },

  {
    path: '/endpoint/:id/edit',
    name: 'Endpoint-Edit',
    component: Edit,
  },

  {
    path: '/endpoint/create',
    name: 'Endpoint-Create',
    component: Create,
  },
];

export default routes;
